import { gql } from '@apollo/client'

export const UpdateUser = gql`
    mutation UpdateUser($updates: UpdateUserInput) {
        updateUser(updates: $updates) {
            id
            avatar
            created
            email
            invites {
                id
                issuer {
                    id
                    username
                }
                room {
                    id
                    name
                    owner {
                        id
                        username
                    }
                }
            }
            rooms {
                id
                name
                topic
                spinning
                owner {
                    id
                    username
                }
                admins {
                    id
                    username
                }
                members {
                    id
                    username
                }
            }
            roles
            updated
            username
        }
    }
`

export default UpdateUser
